import { useState } from 'react'
import { useElementEventListener } from './useElementEventListener'

export function useElementHover(element: HTMLElement | null) {
  const [hover, setHover] = useState(false)

  useElementEventListener(element, 'mouseenter', () => setHover(true))
  useElementEventListener(element, 'mouseleave', () => setHover(false), hover)

  return hover
}
